<template>
  <div>
    <form @submit.prevent="saveMenuItem">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <span class="pl-2">
            {{ input ? "Edit" : "Add" }} Menu Item
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="3">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="3" :class="{ 'form-error': errors.first('outletCode') }">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first("outletCode") }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Is Taxable</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isTaxable" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Menu Item Code</label>
              </b-col>
              <b-col md="3" :class="{ 'form-error': errors.first('menuItemCode') }">
                <b-form-input
                  v-model="obj.menuItemCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="menuItemCode"
                />
                <small>{{ errors.first("menuItemCode") }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Is Active</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isActive" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Menu Group Code</label>
              </b-col>
              <b-col md="3" :class="{ 'form-error': errors.first('menuGroupCode') }">
                <b-form-input
                  v-model="obj.menuGroupCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="menuGroupCode"
                />
                <small>{{ errors.first("menuGroupCode") }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Is CD</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.isCD" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Menu Name</label>
              </b-col>
              <b-col md="3" class="mt-1" :class="{ 'form-error': errors.first('name') }">
                <b-form-input v-model="obj.name" type="text" name="name" />
                <small>{{ errors.first("name") }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Description</label>
              </b-col>
              <b-col md="3" class="mt-1" :class="{ 'form-error': errors.first('description') }">
                <b-form-input v-model="obj.description" type="text" name="description" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Sequence</label>
              </b-col>
              <b-col md="3" class="mt-1" :class="{ 'form-error': errors.first('sequence') }">
                <b-form-input
                  v-model.number="obj.sequence"
                  v-validate="'required|numeric'"
                  type="number"
                  name="sequence"
                />
                <small>{{ errors.first("sequence") }}</small>
              </b-col>

              <b-col md="1" />
              <b-col md="2">
                <label style="height: auto">
                  Produced
                </label>
              </b-col>
              <b-col md="3" class="mt-1" :class="{ 'form-error': errors.first('itemProduced') }">
                <b-form-radio-group
                  v-model="obj.itemProduced"
                  :options="radioOptions"
                  name="itemProduced"
                  class="item-produced"
                />
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="3">
                <label>OrderType</label>
              </b-col>
              <b-col
                md="6"
                class="mt-1 orderTypeCheck"
                :class="{ 'form-error': errors.first('orderType') }"
              >
                <b-form-checkbox
                  v-for="item in options"
                  v-show="item.value!==constants.OTHERS"
                  :id="'checkbox-' + item.value"
                  :key="item.value"
                  v-model="item.status"
                  :name="'checkbox-' + item.value"
                >
                  {{ item.value }}
                </b-form-checkbox>
                <small>{{ errors.first("orderType") }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <b-tooltip target="tooltip-target-1" triggers="hover">For best result, menu image must be a PNG or JPEG, up to 1 MB, with minimum dimension 414 px by 400 px</b-tooltip>
                <label id="tooltip-target-1">Menu Image</label>
              </b-col>
              <b-col md="5" class="mt-1">
                <b-form-file
                  v-model="file"
                  type="file"
                  placeholder="Upload image"
                  accept="image/jpeg, image/jpg, image/png"
                  drop-placeholder="Drop file here..."
                  class="upload-image"
                  name="image"
                  multiple
                  @change="changeImage"
                />
                <b-img
                  v-if="obj.preViewImage || obj.imageBoDisplay"
                  style="width: 100%"
                  :src="obj.preViewImage || obj.imageBoDisplay"
                  alt="Menu Image"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn v-if="submitLoading" type="submit" disabled variant="success">
            Uploading
          </b-btn>
          <b-btn
            v-if="!submitLoading"
            type="submit"
            variant="success"
          >
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import { getResponseToMTH } from '@/utils/helpers';
import { firebaseStorage } from '@/firebase';
import constants from '@/utils/constants';
export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {},
      file: [],
      orderTypes: [],
      submitLoading: false,
      radioOptions: [{ text: 'Kitchen', value: 1 }, { text: 'Bar', value: 2 }],
      constants,
      options: [
        {
          value: constants.HMD,
          status: false
        },
        {
          value: constants.QRO,
          status: false
        },
        {
          value: constants.PPDI,
          status: false
        },
        {
          value: constants.PPTA,
          status: false
        },
        {
          value: constants.TOP,
          status: false
        },
        {
          value: constants.OTHERS,
          status: true
        },
        {
          value: constants.ROOM,
          status: false
        }
      ]
    };
  },

  computed: {
    getOpenScheduleConfig() {
      return _.values(this.$store.getters.GetOpenScheduleConfig.ORDER_TYPES);
    }
  },

  mounted() {
    this.checkOrderType();
    this.checkScheduleConfig();
  },

  methods: {
    // add and update records
    async uploadImages() {
      const task = this.file.map(v => {
        return firebaseStorage
          .ref()
          .child(`MenuImages/${v.name}`)
          .put(v);
      });
      return Promise.all(task);
    },

    saveMenuItem() {
      this.$validator.validate().then(valid => {
        if (
          !this.obj.outletCode ||
          !this.obj.menuItemCode ||
          !this.obj.menuGroupCode
        ) {
          return;
        }
        this.submitLoading = true;
        delete this.obj.preViewImage;
        delete this.obj.imageBoDisplay;
        try {
          this.uploadImages().then(res => {
            if (res[0]) {
              this.obj.image = res[0].metadata.name;
            }
            if (valid) {
              this.formatOrderType();
              if (this.input === null) {
                this.$store
                  .dispatch('CreateMenuItem', this.obj)
                  .then(response => {
                    this.submitLoading = false;
                    let res = getResponseToMTH(
                      response,
                      this.$swal,
                      'Record is created'
                    );
                    if (res) {
                      this.$emit('discard-modal', true);
                      this.reset();
                    }
                  })
                  .catch(error => {
                    this.submitLoading = false;
                    this.$swal(
                      constants.SOMETHING_WROING,
                      error.response.data.message,
                      constants.STATUS_ERROR
                    );
                  });
              } else {
                this.$store
                  .dispatch('UpdateMenuItem', this.obj)
                  .then(response => {
                    this.submitLoading = false;
                    let res = getResponseToMTH(
                      response,
                      this.$swal,
                      constants.RECORD_IS_UPDATED
                    );
                    if (res) {
                      this.$emit('discard-modal', true);
                      this.reset();
                    }
                  })
                  .catch(error => {
                    this.submitLoading = false;
                    this.$swal(
                      constants.SOMETHING_WROING,
                      error.response.data.message,
                      constants.STATUS_ERROR
                    );
                  });
              }
            }
          });
        } catch {
          this.submitLoading = false;
          this.$swal('Upload image failed!', '', constants.STATUS_WARNING);
        }
      });
    },

    checkScheduleConfig() {
      this.$store.dispatch('GetOpenScheduleConfig');
    },

    checkOrderType() {
      if (this.input) {
        this.input.order_type.split(',').map(v => {
          this.options.filter(item => item.value === v)[0].status = true;
        });
      }
    },

    formatOrderType() {
      this.options.map(v => {
        if (v.value && v.status) {
          this.orderTypes.push(v.value);
        }
      });
      this.obj.order_type = this.orderTypes.join(',');
      this.orderTypes = [];
    },

    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          cond: '',
          code: '',
          description: '',
          sequence: 0
        };
      } else {
        this.obj = this.input;
      }
    },
    changeImage(e) {
      const file = e.target.files[0];
      const obj = _.cloneDeep(this.obj);
      let url = '';
      obj.image = url;
      obj.preViewImage = url;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        url = this.result;
        obj.preViewImage = url;
      };
      this.obj = obj;
    }
  }
};
</script>
